import request from 'axios';
import cn from 'classnames';
import { Formik } from 'formik';
import * as React from 'react';
import { themr } from 'react-css-themr';
import * as _yup from 'yup';
import Input from '../Input';
import Textarea from '../Textarea';
const yup = _yup;
function Item({ field, formProps, theme = {}, }) {
    if (field.type === 'textarea') {
        return (React.createElement(Textarea, { name: field.field, label: field.label, helpText: field.helpText, errorText: formProps.touched[field.field]
                ? formProps.errors[field.field]
                : undefined, inputProps: {
                name: field.field,
                value: formProps.values[field.field],
                onChange: formProps.handleChange,
                onBlur: formProps.handleBlur,
            }, theme: theme }));
    }
    const errorText = formProps.touched[field.field]
        ? formProps.errors[field.field]
        : undefined;
    const successText = formProps.touched[field.field] && !formProps.errors[field.field]
        ? field.successText
        : undefined;
    const helpText = !successText ? field.helpText : undefined;
    return (React.createElement(Input, { name: field.field, label: field.label, helpText: helpText, errorText: errorText, successText: successText, inputProps: {
            name: field.field,
            type: field.type,
            value: formProps.values[field.field],
            onChange: formProps.handleChange,
            onBlur: formProps.handleBlur,
        }, theme: theme }));
}
function makeValidationSchema(fields) {
    const tmp = fields.reduce((acc, field) => {
        const { validateType, validators = [] } = field;
        if (!validateType) {
            return acc;
        }
        if (!yup[validateType]) {
            return acc;
        }
        let fieldValidator = yup[validateType]();
        validators.forEach(item => {
            const { params = [] } = item;
            if (item.name === 'matches') {
                const [regex, errorMessage] = params;
                fieldValidator = fieldValidator.matches(new RegExp(regex), errorMessage);
            }
            else {
                fieldValidator = fieldValidator[item.name](...params);
            }
        });
        return {
            ...acc,
            [field.field]: fieldValidator,
        };
    }, {});
    return yup.object().shape(tmp);
}
const DumpForm = ({ form, overrideValues, subscribeEndpoint, onComplete, onError, theme = {}, }) => (React.createElement(Formik, { initialValues: form.defaultValues, validationSchema: makeValidationSchema(form.fields), onSubmit: (values, { setSubmitting, resetForm /* setErrors, setValues and other goodies */ }) => {
        const data = {
            ...values,
            ...overrideValues,
            code: form.code,
            url: typeof window !== 'undefined' && window.location.href,
        };
        request
            .post(subscribeEndpoint, data)
            .then(() => {
            if (onComplete) {
                onComplete(data);
            }
            else {
                alert(`Cám ơn bạn đã liên hệ, chúng tôi sẽ liên hệ với bạn trong thời gian sớm nhất!`);
            }
            resetForm();
        })
            .catch(() => {
            if (onError) {
                onError(data);
            }
            else {
                alert(`Không thể gửi! Bạn vui lòng điền lại thông tin.`);
            }
        })
            .finally(() => {
            setSubmitting(false);
        });
    }, render: formProps => {
        const { handleSubmit, isSubmitting } = formProps;
        return (React.createElement("form", { className: theme.root, onSubmit: handleSubmit },
            React.createElement("div", null, form.fields.map(field => {
                return (React.createElement(Item, { key: field.field, field: field, formProps: formProps, theme: theme.formItem }));
            })),
            React.createElement("div", { className: "flex justify-center" },
                React.createElement("button", { className: cn(theme.submitButton, {
                        [theme.submitButtonSubmiting || '']: !isSubmitting,
                        [theme.submitButtonNotSubmiting || '']: isSubmitting,
                    }), disabled: isSubmitting, type: "submit" },
                    !isSubmitting && form.submitText,
                    isSubmitting && 'Đang gửi...'))));
    } }));
export const defaultFormTheme = {
    submitButton: 'ph4 pv3 pointer pf f6 f5-ns fw9 white ttu bn outline-0',
    submitButtonSubmiting: 'bg hover-bg-rc-dark',
    submitButtonNotSubmiting: 'bg-gray',
};
export default themr('Form', {}, { composeTheme: 'softly' })(DumpForm);
//# sourceMappingURL=index.js.map